import React, { useState } from 'react';
import { Box } from '@mui/material';
import { Form, FormInput, FormButton } from '../../../Common';
import { authService } from '../../../../services';
import { toast } from 'react-toastify';
import './EditUserForm.css';

interface EditUserFormProps {
  adminId: string;
  initialName: string;
  initialEmail: string;
  onSuccess?: () => void;
  onCancel?: () => void;
}

interface EditUserFormData {
  name: string;
  email: string;
}

const EditUserForm: React.FC<EditUserFormProps> = ({ 
  adminId,
  initialName,
  initialEmail,
  onSuccess, 
  onCancel 
}) => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (data: EditUserFormData) => {
    try {
      setLoading(true);
      
      const response = await authService.editAdmin(adminId, { 
        name: data.name.trim(), 
        email: data.email.trim() 
      });
      
      console.log('✅ Edit admin response:', response);
      
      toast.success('User updated successfully');
      
      // Notify parent
      if (onSuccess) {
        onSuccess();
      }
    } catch (error: any) {
      console.error('Failed to edit user:', error);
      toast.error(error?.response?.data?.message || 'Failed to update user');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form<EditUserFormData>
      onSubmit={handleSubmit}
      defaultValues={{ name: initialName, email: initialEmail }}
      resetOnSubmit={false}
    >
      {/* Form Fields */}
      <Box className="edit-user-form-fields">
        <FormInput
          name="name"
          label="Name"
          placeholder="Enter name"
          disabled={loading}
          required
        />
        <FormInput
          name="email"
          label="Email address"
          placeholder="Enter email"
          type="email"
          disabled={loading}
          required
        />
      </Box>

      {/* Action Buttons */}
      <Box className="edit-user-form-actions">
        <FormButton
          type="submit"
          primary
          disabled={loading}
          size="full"
        >
          {loading ? 'Saving...' : 'Save changes'}
        </FormButton>
        <FormButton
          type="button"
          primary={false}
          bordered={false}
          onClick={onCancel}
          size="full"
          disabled={loading}
        >
          Cancel
        </FormButton>
      </Box>
    </Form>
  );
};

export default EditUserForm;

